import { render, staticRenderFns } from "./Slick.vue?vue&type=template&id=35e7721a"
import script from "./Slick.vue?vue&type=script&lang=js"
export * from "./Slick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports